import {useCallback} from 'react';
import sdk from '@/sdk';
import mentionCache from '@/utils/document/mentionCache';
import toast, {ToastType} from '@/components/Toast';
import kuPiper from '@/middleware/kuPiper';

const sendNotify = kuPiper.runProxy(kuPiper.proxyNameMap.sendRlNotifyProxy, (mentions, options, docInfo, relation) => {
    return sdk.as.sendNotifyOfMention({
        mentions,
        mode: options.notifyType,
        message: options.message,
        needVersion: options.needVersion,
    }, docInfo, relation);
});
// 发送如流通知
export const useSendRlNotify = () => {
    return useCallback(
        async (
            mentions: Array<{
                mentionId: string;
                userId?: string;
                // 1：划线评论，2：正文, 3: 底部评论
                from: number;
                // mention 所在的评论id
                commentId?: string;
                // 5-用户 7-群聊
                mentionType?: number;
                gid?: string;
                name?: string;
            }>,
            options: {
                notifyType: number;
                message?: string;
                needVersion?: boolean;
            },
            docInfo: {
                spaceGuid: string;
                groupGuid: string;
                repositoryGuid: string;
                docGuid: string;
            },
            relation?: {
                type: string;
                id: string;
                docGuid: string;
            },
            createTime?: number
        ) => {
            if (!mentions.length) {
                return;
            }
            try {
                await sendNotify(mentions, options, docInfo, relation, createTime);
                mentions.forEach(item => {
                    if (item.from === 3) { // 底部评论
                        mentionCache.delete(item.mentionId.split('_')[1]);
                    }
                    else {
                        mentionCache.delete(item.mentionId);
                    }
                });
            }
            catch (err: any) {
                const code = err.code;
                // @群聊时，不在群内，则提示发送通知失败
                if (code === 40129) {
                    const result = err.result.result;
                    const groupsNameList: any = [];
                    result.forEach((item: any) => {
                        mentions.forEach(mention => {
                            if (item === mention.gid) {
                                groupsNameList.push(mention.name);
                            }
                        });
                    });
                    let toastName = groupsNameList.join('、');
                    if (toastName.length > 15) {
                        toastName = toastName.slice(0, 15) + '...';
                    }
                    setTimeout(() => {
                        toast({
                            type: ToastType.Error,
                            content: `向（${toastName}）发送如流通知失败`,
                        });
                    }, 500);
                }
            }
        },
        []
    );
};

// 记录提及信息，但不发送通知场景（不勾选发送通知或撤销通知），目前主要用于“关于我的”面板
export const useRecordNotNotify = () => {
    return useCallback(
        async (
            mentions: Array<{
                mentionId: string;
                userId?: string;
                // 1：划线评论，2：正文, 3: 底部评论
                from: number;
                // mention 所在的评论id
                commentId?: string;
                // 5-用户 7-群聊
                mentionType?: number;
                gid?: string;
                name?: string;
                notifyStatus?: number;
            }>,
            options: {
                notifyType: number;
                message?: string;
                needVersion?: boolean;
                isCollectMention?: boolean;
            },
            docInfo: {
                spaceGuid: string;
                groupGuid: string;
                repositoryGuid: string;
                docGuid: string;
            },
            relation?: {
                type: string;
                id: string;
                docGuid: string;
            }
        ) => {
            if (!mentions.length) {
                return;
            }

            mentions.forEach(item => {
                item.notifyStatus = 0;
            });

            if (options.isCollectMention) {
                return sdk.as.collectMention({
                    docGuid: docInfo.docGuid,
                    mentions,
                    relation: relation
                        ? {
                            type: 'rightComment',
                            id: relation.id,
                        } : undefined,
                });
            }

            try {
                await sdk.as.sendNotifyOfMention({
                    mentions,
                    mode: options.notifyType,
                    message: options.message,
                    needVersion: options.needVersion,
                }, docInfo, relation);

                mentions.forEach(item => {
                    if (item.from === 3) { // 底部评论
                        mentionCache.delete(item.mentionId.split('_')[1]);
                    }
                    else {
                        mentionCache.delete(item.mentionId);
                    }
                });
            } catch (err: any) {
                console.log(err);
            }
        },
        []
    );
};
